<style scoped lang="less">
.layout{width: 820px;height: 320px;background: rgba(34, 85, 172, 0.88);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;transform: translate(-50%, -50%);border: 1px solid #6491e0;border-radius: 6px;}
.title{height: 35px;background-color: #2080ff;margin: 0;line-height: 35px;text-align: right;padding: 0 20px;color: #fff; font-size: 16px;display: flex;justify-content: space-between;
  .btn-list{display: flex;
    span{margin-left: 15px;}
  }}
.popup-tool {height: 45px;line-height: 45px;color: #fff; font-family: Microsoft YaH;text-align: left;padding: 0px 10px;border:solid 1px rgb(33, 185, 191)}
.popup-content {height:88%;color: #d6d4d4; font-family: Microsoft YaH;text-align: left;padding: 5px;border-top: none;}
.ol-popup-isshow:after {content: "⼀";color: #fff;display:block;}
.ol-popup-closer:after {content: "✖";color: #fff;}
/deep/.el-input.is-disabled .el-input__inner {background: rgba(10, 17, 43, 0.4);border: solid 1px #3c818d;}
/deep/.el-select .el-input.is-disabled .el-input__inner:hover {border: solid 1px #3c818d;}
/deep/.el-form-item__label {padding: 0;color: #fff;text-align: center;}
/deep/.el-form-item {margin: 15px;}
/deep/.el-input__inner {color: #000;}
.markbox {height: 40px;width: 250px;display: flex;flex-direction: row; justify-content:space-around;padding: 0;margin: 0;list-style: none;}
.el-radio-button {width: 40px;height: 40px;}
/deep/.el-radio-button__inner {width: 40px;height: 40px;}
/deep/.el-radio-button__inner img{width: 40px;height: 40px;position: absolute;top: 0px;left: 0px;}
.el-button {border-radius: 4px;border: solid 1px #2080ff;}
.el-button--primary {color: #FFF;background-color: #2080ff;}
.el-button--default {color: #FFF;background: #2080ff;}
/deep/.el-input__inner{ background-color: transparent !important; border: solid 1px #7ae9ff;border-radius: 5px;color: #fff;}
/deep/.el-table {height: 100%;}
.el-table .cell .el-button{border: none;}
/deep/.el-table__body-wrapper{    height: 85%;
    overflow: auto;}

/*最外层透明*/
/deep/ .el-table,
/deep/ .el-table__expanded-cell {
  background-color: transparent;
  color: #ffffff;
}
/* 表格内背景颜色 */
/deep/ .el-table th,
/deep/ .el-table tr,
/deep/ .el-table td {
  background-color: transparent !important;
  //表格字体颜色
  color: #ffffff;
}
/deep/.el-table td, .el-table th.is-leaf {border: none;}
</style>

<template>
<div class="layout" v-drag v-if="flag">
    <div class="title">
      <span>查询结果</span>
      <div class="btn-list">
        <span href="#" id="popup-closer" class="ol-popup-isshow" @click="miniMize()"></span>
        <span href="#" id="popup-closer" class="ol-popup-closer" @click="showLP()"></span>
      </div>
    </div>
    <!-- <p class="title">
      <span>查询结果</span>
      <a href="#" id="popup-closer" class="ol-popup-isshow" @click="miniMize()"></a>
      <a href="#" id="popup-closer" class="ol-popup-closer" @click="showLP()"></a>
    </p> -->
    <div class="popup-content">
      <el-table
        :data="tableData"
        style="width: 100%">
        <div v-for="data in this.listRow" :key="data">
          <el-table-column v-if="data.label!=='操作'"
              :prop="data.prop"
              :label="data.label"
              :show-overflow-tooltip="true"
              >
          </el-table-column>
          <el-table-column v-if="data.label==='操作'"
              :prop="data.prop"
              :label="data.label"
              >
              <template #default="scope">
                <el-button @click="positioning(scope.row)" type="text" >定位</el-button>
              </template>
          </el-table-column>
        </div>
      </el-table>
    </div>
    <!-- <el-pagination
          class="el_pag"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 50, 100, 200, 500]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
    </el-pagination> -->
  </div>
</template>

<script>
export default {
  props: ['searchData'],
  data()
  {
    return {
      flag: false,
      form: {
        longitude: '',
        latitude: ''
      },
      currentPage: '1',
      pagesize: 20,
      total: 0,
      LayernarData: [],
      tableData: [],
      listRow: []
    }
  },
  created()
  {
  },
  methods: {
    setDataCon(data)
    {
      if (data.length > 0)
      {
        this.flag = true
        let newArray = data.map(object =>
        {
          // 使用解构赋值来去掉 OBJECTID 属性
          const { OBJECTID, ...rest } = object
          // 返回去掉指定属性的对象
          return rest
        })
        this.listRow.splice(0, this.listRow.length)
        Object.keys(newArray[0]).forEach(item =>
        {
          this.listRow.push({label: item, prop: item})
        })
        this.listRow.push({label: '操作', prop: 'cz'})
        this.tableData = newArray
        this.total = newArray.length
      }
      else
      
        this.flag = false
    },
    showLP()
    {
      this.flag = !this.flag
      this.$emit('delPos')
    },
    isShow()
    {
      this.flag = !this.flag
    },
    miniMize()
    {
      this.$emit('minPos')
    },
    handleSizeChange(val)
    {
      this.pagesize = val
    },
    handleCurrentChange(val)
    {
      this.currentPage = val
    },
    // 定位
    positioning(val)
    {
      this.$emit('positionPoint', val)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/kyxxyzt/SearchResult.vue